<template>
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <div class="header-nav-logo">
        <img src="@/assets/img/u7.png">
      </div>
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="{active:index==navIndex}"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <i class="underline"></i>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/u7.png" alt="logo">
      </div>
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="{active:index==navIndex}"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">{{item.name}}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') || 0,
      menuName: "Home",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        { name: "Home", path: "/" },
        { name: "Products", path: "/products" },
        { name: "About us", path: "/companyintroduction" },
        { name: "News", path: "/newsinformation" },
        { name: "Contact", path: "/contactus" }
      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index);
      this.menuName = name;
    },
    menuClick() {
      this.menuClass = this.menuClass === "glyphicon glyphicon-menu-down"
        ? "glyphicon glyphicon-menu-up"
        : "glyphicon glyphicon-menu-down";
    }
  }
};
</script>

<style scoped>
/* ---------- 通用 ---------- */
#header{
  background:#f4f4f4;
  font-size:15px;
}
a{
  color:#28a745;
  text-decoration:none;
}
a:hover{
  color:#28a745;
}

/* ---------- 电脑导航 ---------- */
.header-nav{
  height:110px;
  display:flex;
  align-items:center;
  justify-content:space-between;
}
.header-nav-logo img{
  width:120px;
  height:auto;
}
.header-nav-wrapper{
  display:flex;
  gap:30px;
  list-style:none;
  margin:0;
  padding:0;
  font-size: 24px;   
  font-weight:bold;
}
.header-nav-wrapper li{
  position:relative;
}
.header-nav-wrapper .active a,
.header-nav-wrapper a:hover{
  color:#28a745;
}
.underline{
  position:absolute;
  left:0;bottom:-2px;
  width:0;height:2px;
  background:#28a745;
  transition:.3s;
}
.header-nav-wrapper li:hover .underline,
.header-nav-wrapper li.active .underline{
  width:100%;
}

/* ---------- 手机导航 ---------- */
.header-nav-m{
  background:#474747;
  color:#28a745;
  position: relative;
  z-index: 1050; 
}
.header-nav-m-logo{
  height:60px;
  display:flex;
  align-items:center;
  justify-content:center;
}
.header-nav-m-logo img{
  max-width: 90px;      
  max-height: 40px;
  width: auto;
  height: auto;
}
.header-nav-m-menu{
  height:50px;
  line-height:50px;
  position:relative;
}
.header-nav-m-menu-wrapper{
  position:absolute;
  right:20px;
  top:50%;
  transform:translateY(-50%);
  font-size:20px;
  cursor:pointer;
}
.header-nav-m-wrapper{
  list-style:none;
  margin:0;
  padding:0;
  background:#474747;
}
.header-nav-m-wrapper li{
  border-bottom:1px solid #ccc;
}
.header-nav-m-wrapper a{
  display:block;
  line-height:40px;
  padding:0 20px;
  color:#28a745;
}
.header-nav-m-wrapper .active a{
  font-weight:bold;
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue